// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__Kpz4U","active":"Loader_active__P4ef2"};